import { render } from "./ConhecimentoNoticias.vue?vue&type=template&id=8a65d854"
import script from "./ConhecimentoNoticias.vue?vue&type=script&lang=js"
export * from "./ConhecimentoNoticias.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__